import { container } from 'tsyringe';
import { ModelManager } from '@/prototyping/model';
import { JsonRpcModule, JsonRpcCallHandler, JsonRpcNotifyHandler } from '../../jrpc/module';

export class VinylPostcardsModule extends JsonRpcModule {
  @JsonRpcCallHandler('getCurrentlySelectedRecordPlayer')
  async getCurrentlySelectedRecordPlayer(): Promise<string> {
    const modelManager = container.resolve(ModelManager);
    const vinylpostcardsSettings = modelManager.get('vinylpostcards', 'VinylPostcardsModel');
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
    const audioInfo = audioLib.getAudioTrackInfo(audioPlayer.currentAudioTrack);

    return audioInfo.value?.recordPlayer ||  vinylpostcardsSettings.state.recordPlayer;
  }

  @JsonRpcNotifyHandler('play')
  play(): void {
    const modelManager = container.resolve(ModelManager);
    const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');
    vinylpostcards.scratchAndPlay(modelManager.get('audio-player', 'AudioPlayerModel'));
  }

  @JsonRpcNotifyHandler('stop')
  stop(): void {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    if (audioPlayer.hasAudioTrack && !audioPlayer.isPlaying.value) audioPlayer.stop();
  }

  @JsonRpcCallHandler('getCurrentPlayingState')
  async getCurrentPlayingState(): Promise<boolean> {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    return audioPlayer.isPlaying.value;
  }

  async changePlayingState(playing: boolean): Promise<void> {
    await this.channel.call('VinylPostcards.ChangePlayingState', [playing]);
  }

  @JsonRpcCallHandler('getCurrentAudioCover')
  async getCurrentAudioCover(): Promise<string> {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const imageTargetTracks = container.resolve(ModelManager).get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');
    const imageTarget = imageTargetTracks.state.imageTargetTracks.find((it) =>
      it.audioTracks.find((at) => at.filename === audioPlayer.currentAudioTrack.value?.src)
    );
    if (imageTarget !== undefined) return imageTarget.imageTargetName;
    return 'None';
  }

  async changeAudioCover(audiofile: string): Promise<void> {
    const imageTargetTracks = container.resolve(ModelManager).get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');
    const imageTarget = imageTargetTracks.state.imageTargetTracks.find((it) => it.audioTracks.find((at) => at.filename === audiofile));
    if (imageTarget) await this.channel.call('VinylPostcards.ChangeAudioCover', [imageTarget.imageTargetName]);
  }
}
